import { useCallback } from 'react'

import { localStorageKeys } from '@sketch/constants'

import { useLocalStorage } from '@sketch/utils'

type AnnotationSettings = {
  hideAnnotationsDots: boolean
}

const useHideAnnotationDots = () => {
  const [annotationsSettings, setUseAnnotationsSettings] =
    useLocalStorage<AnnotationSettings>(
      localStorageKeys.userAnnotationSettings,
      { hideAnnotationsDots: false }
    )

  const setHideAnnotationDots = useCallback(
    (hideAnnotationsDots: boolean) => {
      setUseAnnotationsSettings((settings: AnnotationSettings) => {
        const newSettings = { ...settings, hideAnnotationsDots }
        return newSettings
      })
    },
    [setUseAnnotationsSettings]
  )

  return [
    annotationsSettings.hideAnnotationsDots,
    setHideAnnotationDots,
  ] as const
}

export default useHideAnnotationDots
